import {isEmpty, startsWith, replace} from 'lodash';
import * as React from 'react';

import {FilterNodeTypeText} from './FilterNodeTypeText';
import {FilterNodeTypeWrapper} from './FilterNodeTypeWrapper';
import {DynamicFilter, Filter, FILTER_TYPE_TEXT} from 'src/js/lib/filtering';
import {FilterNode as FilterNodeModel} from 'src/js/model/filters_config';

interface OwnProps {
  inputRef: (inputElement: HTMLInputElement) => void;
  isOpened?: boolean;
  node: FilterNodeModel;
  changeFilter: (filter: Filter) => void;
  removeFilter: (filter: Filter) => void;
  selectedFilter?: Filter;
  setFocus: () => void;
  toggleOpened: () => void;
  isMui?: boolean;
  wrapperWidth?: string;
  inputWidth?: string;
  iconName?: string;
}

type Props = OwnProps;

export const FilterNodeTypeTextContainer: React.FC<Props> = (props) => {
  const {
    inputRef,
    isOpened = false,
    node,
    toggleOpened,
    removeFilter,
    selectedFilter,
    setFocus,
    isMui,
    changeFilter,
    wrapperWidth,
    inputWidth,
    iconName,
  } = props;

  const handleChange = (event) => {
    if (event) {
      event.stopPropagation();
    }
    changeOrRemoveFilter(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.stopPropagation();
      changeOrRemoveFilter(event.target.value);
    }
    return true;
  };

  const getFilter = (value) => {
    const TextFilter = DynamicFilter.getFilterClass(FILTER_TYPE_TEXT);
    return new TextFilter({
      node,
      type: FILTER_TYPE_TEXT,
      property: node.getName(),
      value,
    });
  };

  const getValue = () => {
    let value = '';
    if (selectedFilter) {
      value = selectedFilter.getValue();
      if (getSearchPrefix()) {
        // remove searchPrefix before setting input value
        value = replace(value, new RegExp(`^${getSearchPrefix()}`), '');
      }
    }
    return value;
  };

  const getSearchPrefix = () => {
    return node.getSearchPrefix();
  };

  const changeOrRemoveFilter = (value) => {
    // add searchPrefix before changing filter value (only if it is not already there)
    const prefix = getSearchPrefix() && !startsWith(value, getSearchPrefix()) ? getSearchPrefix() : '';
    const filter = getFilter(prefix + value);
    if (isEmpty(value)) {
      removeFilter(filter);
    } else {
      changeFilter(filter);
    }
  };

  const filter = getFilter();

  return (
    <FilterNodeTypeWrapper
      filter={filter}
      isOpened={isOpened}
      node={node}
      removeFilter={removeFilter}
      setFocus={setFocus}
      selectedFilter={selectedFilter}
      toggleOpened={toggleOpened}
      isMui={isMui}
    >
      <FilterNodeTypeText
        handleChange={handleChange}
        inputRef={inputRef}
        isOpened={isOpened}
        value={getValue(filter)}
        searchPrefix={getSearchPrefix()}
        isMui={isMui}
        label={node.getLabel()}
        handleKeyDown={handleKeyDown}
        wrapperWidth={wrapperWidth}
        inputWidth={inputWidth}
        iconName={iconName}
      />
    </FilterNodeTypeWrapper>
  );
};

FilterNodeTypeTextContainer.displayName = 'FilterNodeTypeTextContainer';
